const queueDefinition = {
  "active-cases-queue": {
    name: "active-cases-queue",
    label: "active-cases-label",
    queueFilter: "?status=active&hasIncidents=false",
    queueSort: "sort=createdAt&dir=-1",
    pollingInterval: 5000
  },
  "failed-cases-queue": {
    name: "failed-cases-queue",
    queueFilter: "?status=active&hasIncidents=true",
    queueSort: "sort=createdAt&dir=-1",
    pollingInterval: 5000,
    limit: 5
  },
  'my-cases': {
    name: 'my-cases',
    queueType: 'assignee',
    queueFilter: '?status=active',
    queueSort: 'sort=createdAt&dir=-1',
    limit: 30
  },
}

export { queueDefinition }
